import React, { useEffect, useState } from "react";
import { IoPersonCircleOutline as AuthorIcon } from "react-icons/io5";
import ReactMarkdown from "react-markdown";
import "github-markdown-css/github-markdown-light.css";
import styles from "./WelcomeWord.module.css";

const parseFrontmatter = (mdText) => {
  const match = mdText.match(/^---\n([\s\S]*?)\n---/);
  if (!match) return { data: {}, body: mdText };

  const body = mdText.slice(match[0].length).trim();
  const data = {};
  match[1].split("\n").forEach((line) => {
    const colonIdx = line.indexOf(":");
    if (colonIdx === -1) return;
    const key = line.slice(0, colonIdx).trim();
    const val = line.slice(colonIdx + 1).trim().replace(/^["']|["']$/g, "");
    data[key] = val;
  });

  return { data, body };
};

export const WelcomeWord = () => {
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [body, setBody] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fetchWelcome = async () => {
      try {
        const res = await fetch(`/content/welcome.md`);
        if (!res.ok) return;
        const mdText = await res.text();
        const { data, body: mdBody } = parseFrontmatter(mdText);
        setTitle(data.title || "");
        setAuthor(data.author || "");
        setBody(mdBody);
        setVisible(true);
      } catch {
        // non-critical — hide on error
      }
    };

    fetchWelcome();
  }, []);

  if (!visible) return null;

  return (
    <div className={styles.welcome}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={`${styles.body} markdown-body`}>
        <ReactMarkdown>{body}</ReactMarkdown>
      </div>
      {author && (
        <div className={styles.author}>
          <AuthorIcon className={styles.author_icon} />
          <span>{author}</span>
        </div>
      )}
    </div>
  );
};
